module.exports = __webpack_public_path__ + "static/media/doc.54eb6ec9.png";